







import Vue from "vue";
export default Vue.extend({
  name: "MapHeader",

  props: {
    title: {
      type: String,
      required: true
    }
  }
});
